import React, { useState, forwardRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { InputHeader } from '../header/InputHeader'
import { InputCore } from '../core/InputCore'
import style from '../input.module.scss'
import cx from 'classnames'
import { VegaIcon } from '../../icon/Icon'

/** Vega input with multiple fields */
const VegaInputMultiple = forwardRef(
	(
		{
			name,
			errors,
			label,
			link,
			placeholder,
			onChange,
			onBlur,
			limit = -1,
			className,
			defaultInputStateList
		},
		ref
	) => {
		const [inputList, setInputList] = useState([
			{ value: '', disabled: false, isNewInput: true }
		])

		useEffect(() => {
			if (defaultInputStateList?.length > 0) {
				setInputList(defaultInputStateList)
			}
		}, [defaultInputStateList])

		useEffect(() => {
			if (onChange) {
				onChange(inputList)
			}
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}, [inputList])
		const handleBlur = (e) => {
			if (onBlur) {
				onBlur(inputList)
			}
		}

		const handleChange = (key, inputValue) => {
			let tempInputList = [...inputList]
			tempInputList[key].value = inputValue
			tempInputList[key].isNewInput = false
			onChange(tempInputList)
		}

		const handleClick = () => {
			setInputList((oldState) => [
				...oldState,
				{ value: '', disabled: false, isNewInput: true }
			])
		}

		const handleRemove = (key) => {
			setInputList(inputList.filter((item) => item !== inputList[key]))
		}

		return (
			<div className={cx(className, style.wrap)}>
				<InputHeader
					label={label}
					link={{
						...link,
						onClick: (e) => handleClick(),
						disabled: limit <= inputList.length
					}}
				/>

				{inputList.map((props, key) => (
					<div key={key} className={style.inputRow}>
						<div className={style.inputItem}>
							<InputCore
								ref={ref}
								className={style.input}
								name={name ? `${name}[${key}]` : null}
								placeholder={placeholder}
								value={props.value}
								disabled={limit <= 0 || props.disabled}
								errorMessage={!props.isNewInput && errors ? errors[key] : null}
								onBlur={(e) => handleBlur(e)}
								onChange={(e) => handleChange(key, e.target.value)}
							/>
						</div>
						<div>
							{!props.disabled && key > 0 && (
								<div className={style.delete}>
									<VegaIcon name={'trash'} onClick={() => handleRemove(key)} />
								</div>
							)}
						</div>
					</div>
				))}
			</div>
		)
	}
)

VegaInputMultiple.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Set action on change */
	onChange: PropTypes.func,
	/** Set action on blur */
	onBlur: PropTypes.func,
	/** Set placeholder of input */
	placeholder: PropTypes.string,
	/** Set label on header of input */
	label: PropTypes.string,
	/** Set props of the button link in the header */
	link: PropTypes.object,
	/** Set value of input */
	value: PropTypes.string,
	/** Set name of input */
	name: PropTypes.string,
	/** Set error messages */
	errors: PropTypes.array,
	/** Set limit of adding fields */
	limit: PropTypes.number,
	/** Set props of inputs */
	inputProps: PropTypes.array,
	/** Set current inputs at disabled state and add another one if possible */
	isSubmited: PropTypes.bool
}

export { VegaInputMultiple }
